import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-84" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-85" data-mp="23wmhx6pahhi6">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-green sm:text-xs" data-id="element-86" data-mp="30lauhni8kck7">
          THE COMPLETE BIOLOGY CURRICULUM
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-deep sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-87" data-mp="2mt4bzurm1thl">
          Teach a Full Year of <span className="italic text-brand-green" data-id="element-88" data-mp="3fibc2y6pqr4y">Biology</span> in Just 5 Minutes of Prep
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-89" data-mp="3k9jjxpsea4g0">
          Biology Ready is a complete, done-for-you curriculum — 10 ready-to-teach volumes packed with clear labeled
          diagrams, activities, labs and assessments, from Grade 1 to Grade 12. Open, teach, and learn.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/w32cPosGqX1bSmRjAfjJnK/ChatGPT_Image_8_ago_2026,_10_18_49-Photoroom.png" alt="The complete Biology Ready bundle: ten primary and secondary volumes, digital lesson materials, lab equipment and five bonus workbooks" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-90" data-mp="2p7em4310eoam" />
        <div className="flex w-full flex-col items-center" data-id="element-91" data-mp="381tl3snbmgyg">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-92" data-mp="336ead9km1169">
            GET THE BIOLOGY READY PACK
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-93" data-mp="18s4zez0rhcw1">
            ✓ Instant digital download <span className="px-1 text-brand-amber" data-id="element-94" data-mp="3dseezasagavf">·</span> ✓ Print-ready PDFs{' '}
            <span className="px-1 text-brand-amber" data-id="element-95" data-mp="3duihppegb3u4">·</span> ✓ One-time payment
          </p>
        </div>
      </motion.div>
    </section>;
}